import React from "react";
import { AddTrusteeContainer } from "../../../containers";

const AddTrustee = (props) => {
  return <AddTrusteeContainer {...props} />;
};

export default AddTrustee;
